import script from "./MobileTab2.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTab2.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTab2.vue?vue&type=style&index=0&id=6e22609a&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e22609a"]])

export default __exports__